import { render, staticRenderFns } from "./CourseMessage.vue?vue&type=template&id=52d04080&"
import script from "./CourseMessage.vue?vue&type=script&lang=js&"
export * from "./CourseMessage.vue?vue&type=script&lang=js&"
import style0 from "./CourseMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports